import script from "./FloorPlanCanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./FloorPlanCanvas.vue?vue&type=script&setup=true&lang=js"

import "./FloorPlanCanvas.vue?vue&type=style&index=0&id=4bb25af4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bb25af4"]])

export default __exports__